import React from 'react';

const MailIcon = props => (
  <svg width='17' height='14' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M15.75 0C16.1642 0 16.5 0.33579 16.5 0.75V12.7549C16.5 13.1664 16.1585 13.5 15.7561 13.5H2.24385C1.83304 13.5 1.5 13.1663 1.5 12.7549V12H15V3.225L9 8.625L1.5 1.875V0.75C1.5 0.33579 1.83579 0 2.25 0H15.75ZM6 9V10.5H0V9H6ZM3.75 5.25V6.75H0V5.25H3.75ZM14.6744 1.5H3.32561L9 6.60698L14.6744 1.5Z'
      fill='#212121'
    />
  </svg>
);

export default MailIcon;
